import { jsx as _jsx } from "react/jsx-runtime";
import { BigmiContext } from '@bigmi/react';
import { ChainType } from '@lifi/sdk';
import { useContext } from 'react';
import { useInternalWalletProvider } from '../../hooks/useInternalWalletProvider.js';
import { isItemAllowed } from '../../utils/item.js';
import { useWidgetConfig } from '../WidgetProvider/WidgetProvider.js';
import { UTXOBaseProvider } from './UTXOBaseProvider.js';
import { UTXOExternalContext } from './UTXOExternalContext.js';
function useInBigmiContext() {
    const { chains } = useWidgetConfig();
    const context = useContext(BigmiContext);
    return Boolean(context) && isItemAllowed(ChainType.UTXO, chains?.types);
}
export const UTXOProvider = ({ children }) => {
    const inBigmiContext = useInBigmiContext();
    const useInternalWallet = useInternalWalletProvider(inBigmiContext);
    return useInternalWallet ? (_jsx(UTXOBaseProvider, { children: children })) : (_jsx(UTXOExternalContext.Provider, { value: inBigmiContext, children: children }));
};
//# sourceMappingURL=UTXOProvider.js.map